import { CircularProgress } from "@mui/material";
import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";

import { useFeature } from "~hooks/useFeature";
import { Route } from "~services/router/Route";

const EmployerHiredSurveyPage = lazy(() =>
  import("./EmployerHiredSurveyPage").then((module) => ({ default: module.EmployerHiredSurveyPage })),
);

export function EmployerHiredSurveyPageRoute() {
  const allowed = useFeature("employerHiredSurvey");
  if (!allowed) {
    return <Navigate replace to={Route.home()} />;
  }

  return (
    <Suspense fallback={<CircularProgress aria-label="Loading employer survey" />}>
      <EmployerHiredSurveyPage />
    </Suspense>
  );
}
